import {
  XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid,
 LineChart, Line,Bar,BarChart,
} from "recharts";

import CountUp from 'react-countup';

import { Box, Typography, Grid, Paper } from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import InstagramIcon from '@mui/icons-material/Instagram';
import TikTokIcon from '@mui/icons-material/MusicNote'; 
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube'
import { useEffect } from "react";
export default function TrainingDashboard() {
   useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top of page when this component loads
    }, []);
  const data = {
    title: "Dereja Website",
    
    stats: {
      Visit:605125,
      Signup: 180703,
      Jobpost: 3397,
      employed: 89321,
      selfEmployed: 4031,
      
    },
  
    yearlysignup: [
      { year: 2020,Signup: 5000 },
      { year: 2021,Signup: 6000 },
      { year: 2022,Signup: 7200},
      { year: 2023,Signup: 8640},
      { year: 2024,Signup: 10368},
      {year:2025,Signup:4136}
    
    ],
     Yearlyplaced: [
      { year: 2020,Reach:15500,Placed: 55000},
      { year: 2021,Reach:45529,Placed: 2773 },
      { year: 2022,Reach:26596,Placed: 5441},
      { year: 2023,Reach:50633,Placed: 9029},
      { year: 2024,Reach:37080,Placed: 12079},
      { year: 2025,Reach:3957,Placed: 4192},
    ],
    
   
  };

const dataa = [
  { category: 'Employed', male: 54032, female: 35289, total: 89321},
  { category: 'Self-Employed', male: 3075, female: 956, total: 4031},
];
  const platforms = [
    { name: 'Telegram', icon: <TelegramIcon sx={{ fontSize: 40, color: '#0088cc' }} />, color: '#0088cc', count: '50.2K', link: 'https://t.me/Derejaofficial' },
    { name: 'LinkedIn', icon: <LinkedInIcon sx={{ fontSize: 40, color: '#0A66C2' }} />, color: '#0A66C2', count: '39K', link: 'https://www.linkedin.com/company/dereja.com/'},
    { name: 'Facebook', icon: <FacebookIcon sx={{ fontSize: 40, color: '#1877F2' }} />, color: '#1877F2', count: '20K',link: 'https://web.facebook.com/DerejaJobs/?_rdc=1&_rdr#'},
    { name: 'Twitter', icon: <TwitterIcon sx={{ fontSize: 40, color: '#1DA1F2' }} />, color: '#1DA1F2', count: '5.6K', link: 'https://x.com/DerejaOfficial' },
    { name: 'Youtube', icon: <YouTubeIcon sx={{ fontSize: 40, color: '#FF3F33' }} />, color: '#FF3F33', count: '4.5K', link: 'https://www.youtube.com/@Gradjobsethiopia' },
    { name: 'Instagram', icon: <InstagramIcon sx={{ fontSize: 40, color: '#F4631E' }} />, color: '#F4631E', count: '1.5K',link: 'https://www.instagram.com/dereja_ethiopia'},
    { name: 'TikTok', icon: <TikTokIcon sx={{ fontSize: 40, color: 'black' }} />, color: 'black', count: '1.6K', link: 'https://www.tiktok.com/@dereja.com?lang=en'}, 
    
  ];


  const COLORS = {
    primary: '#FE5D26',
    secondary: '#FF9B45',
    accent: '#E52020',
    light: '#FFC107',
    dark: '#333333'
  };

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-8">
     
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">{data.title}</h1>
        <p className="text-gray-600">A career development platform that connects Ethiopian youth with job opportunities, career guidance, and employability resources.</p>
      </div>

      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
       
        <div 
          className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FE5D26]"
          data-tooltip-id="university-tooltip"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Website Visit</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.Visit} duration={2} />
              </h3>
              
            </div>
            <div className="bg-[#FFE9E1] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#E52020]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
          </div>

           </div>
          
        {/* Total Trained */}
        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FF9B45]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Signup</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.Signup} duration={2} separator="," />
              </h3>
            </div>
             <div className="flex flex-col items-center justify-center">
      <div className="bg-[#FFE9E1] p-3 rounded-full">
        <svg className="w-6 h-6 text-[#FF9B45]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
      </div>
      <p className="text-[10px] font-semibold text-orange-600 mt-2">20% Female</p>
    </div>
          
          </div>

           
        </div>

        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FFC107]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Placement</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.employed + data.stats.selfEmployed} duration={2} separator="," />
              </h3>
            </div>
             <div flex flex-col items-center justify-center>
            <div className="bg-[#FFF8E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FFC107]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <p className="text-[14px] font-semibold text-orange-600 mt-2">39% Female</p>
            </div>
          </div>
        </div>

         <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#E52020]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Job Post</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.Jobpost} duration={2} />
              </h3>
            </div>
           
            <div className="bg-[#FFE5E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FE5D26]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              
            </div>
            
           
          </div>
        </div>

       
       
      </div>

      {/* Main Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
        {/* Yearlyplaced Line Chart */}
<div className="bg-white p-6 rounded-xl shadow-md">
  <h3 className="text-lg font-semibold text-gray-800 mb-4">Yearly Signup Trends</h3>
  <div className="h-80">
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data.yearlysignup}>
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
        <XAxis dataKey="year" stroke="#666" />
        <YAxis stroke="#666" />
        <Tooltip 
          contentStyle={{ backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #ddd" }}
          labelStyle={{ color: "#333" }}
          cursor={{ stroke: '#ccc', strokeWidth: 1 }}
        />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="Signup" 
          stroke={COLORS.secondary} 
          strokeWidth={3} 
          dot={{ fill: COLORS.secondary, strokeWidth: 2, r: 5 }}
          activeDot={{ r: 7, fill: COLORS.secondary }}
          name="Signup"
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>


<div className="relative group">
  <div className="bg-white p-6 shadow-md transition duration-300 group-hover:shadow-lg">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">Yearly Reach Vs Placement Trends</h3>
    <div className="h-80">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data.Yearlyplaced} barGap={8}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis dataKey="year" stroke="#666" />
          <YAxis stroke="#666" />
          <Tooltip
            contentStyle={{ backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #ddd" }}
            labelStyle={{ color: "#333" }}
            cursor={{ fill: "#f5f5f5" }}
          />
          <Legend />
          <Bar
            dataKey="Reach"
            fill={COLORS.primary}
            name="Reach"
            
          />
          <Bar
            dataKey="Placed"
            fill={COLORS.secondary}
            name="Placement"
            
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
  </div>
<div className="bg-white p-6 rounded-xl shadow-md">
  <h3 className="text-lg font-semibold text-gray-800 mb-4">Placement Breakdown</h3>
  <div className="h-80">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart 
        data={dataa} 
        barGap={8}
        margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
        <XAxis 
          dataKey="category" 
          tickLine={false} 
          axisLine={{ stroke: '#E5E7EB' }} 
          tick={{ fill: '#6B7280', fontSize: 12 }}
          padding={{ left: 20, right: 20 }}
        />
        <YAxis 
          axisLine={{ stroke: '#E5E7EB' }} 
          tickLine={false}
          tick={{ fill: '#6B7280', fontSize: 12 }}
          domain={[0, 100]}
          tickFormatter={(value) => `${value}`}
        />
        
        <Tooltip 
          formatter={(value, name) => [`${value}`, 
            {male: 'Male', female: 'Female', total: 'Total'}[name]
          ]}
          contentStyle={{
            background: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }}
          labelFormatter={(label) => `Category: ${label}`}
          labelStyle={{ fontWeight: 500, color: '#111827' }}
        />
         <Bar 
          name="Total" 
          dataKey="total" 
          fill="#8BC34A" 
          barSize={24} 
          radius={[4, 4, 0, 0]} 
        />
        <Bar 
          name="Male" 
          dataKey="male" 
          fill="#4A90E2" 
          barSize={24} 
          radius={[4, 4, 0, 0]} 
        />
        <Bar 
          name="Female" 
          dataKey="female" 
          fill="#FF9B45" 
          barSize={24} 
          radius={[4, 4, 0, 0]} 
        />
        <Legend 
          verticalAlign="top" 
          iconType="circle" 
          wrapperStyle={{ paddingBottom: '20px' }}
          formatter={(value) => (
            <span className="text-sm text-gray-600">{value}</span>
          )}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>
</div>
      </div>
 <Box sx={{ p: 2, bgcolor: 'white', borderRadius: 2, boxShadow: 2, mb: 4 }}>
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Dereja Social Media Subscribers As of 2025
      </Typography>
      <Grid container spacing={12}>
        
        {platforms.map((platform, index) => (
          
          <Grid item xs={6} sm={4} md={2} key={index}>
            <a
        key={index}
        href={platform.link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: 'center', 
                borderRadius: 2,
                bgcolor: `${platform.color}20`, 
              }}
            >
              {platform.icon}
              <Typography variant="h6" fontWeight="bold" sx={{ color: platform.color, mt: 1 }}>
                {platform.count}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {platform.name}
              </Typography>
            </Paper>
            </a>
          </Grid>
        ))}
      </Grid>

      <Box mt={3} p={2} bgcolor="grey.100" borderRadius={2}>
        <Typography variant="body2" fontStyle="italic" color="text.secondary">
          "Our growing community of subscribers across platforms helps us make a greater impact."
        </Typography>
      </Box>
    </Box>
    </div>
    
  );
}